import { useCallback, useRef, memo, useState } from "react";
import { GoogleMap, MarkerF, InfoWindowF } from "@react-google-maps/api";

const mapContainerStyle = {
	height: "60vh",
	width: "100%",
};

const center = {
	lat: 6.4589814518399375,
	lng: 3.4722094582606133,
};

const options = {
	disableDefaultUI: true,
	zoomControl: true,
};

const initialValues = {
	latitude: center.lat,
	longitude: center.lng,
};

const Map = () => {
	const [selected, setSelected] = useState(initialValues);

	const mapRef = useRef();

	const onMapLoad = useCallback((map) => {
		mapRef.current = map;
	}, []);

	return (
		<div>
			<GoogleMap
				id="map"
				mapContainerStyle={mapContainerStyle}
				zoom={14}
				center={center}
				options={options}
				// onClick={onMapClick}
				onLoad={onMapLoad}
			>
				<MarkerF
					position={{
						lat: Number(center.lat),
						lng: Number(center.lng),
					}}
					onClick={() => setSelected(initialValues)}
				/>

				{selected ? (
					<InfoWindowF
						position={{
							lat: Number(center.lat) + 0.0032,
							lng: Number(center.lng),
						}}
						onCloseClick={() => {
							setSelected(null);
						}}
						style={{ zIndex: 10, top: "10px !important" }}
					>
						<div style={{ fontWeight: "bold" }}>
							Plot 2b, Fatai Arobieke Street. off Admiralty Road. Lekki. Lagos
							<br />
							<a
								target="_blank"
								rel="noopener noreferrer"
								href={`https://www.google.com/maps/dir/?api=1&destination=${center.lat},${center.lng}`}
							>
								Get Directions
							</a>
						</div>
					</InfoWindowF>
				) : null}
			</GoogleMap>
		</div>
	);
};

export default memo(Map);
